module.exports = {
      id: "mobile-share-usage",
      viewBox: "0 0 16.211 17.807",
      url: "/" + "sprite-0c9f646beffa24bb04e01488ef4c0ff4.svg#mobile-share",
      toString: function () {
        return this.url;
      }
    }